import { compose } from 'recompose';
import ScrollToBottomButton from './scrollToBottomButton';

const enhance = compose(
);
export default enhance(ScrollToBottomButton);
